import HTTP from '../lib/http'

// 帮助文档
function getHelpContent() {
  return HTTP.get(`https://bieyangapp.com/static/curation/help.json`, {})
}

export {
  getHelpContent,
}